exports.sensors.EZO_PH = Class.extend({
	init: function(chip_address) {
		this.__chip_address = chip_address;
	},
	measure: function() {
		this.onresult = function(value) {
			this.__value = parseFloat(value);
		}.bind(this);
		this.__value = null;
		this.command("R");
	},
	value: {
		get: function() {
			return(this.__value);
		},
		configurable: true
	},
	command: function(cmd) {
		try {
			gpio.i2c.writeBlockData(this.__chip_address, cmd + "\r");
		} catch(e) {
			if (typeof this.onerror == "function") {
				this.onerror(e.message);
			}
		}

		setTimeout(function _() {
			try {
				var arraybuffer = gpio.i2c.readBlockData(this.__chip_address, 31);
			} catch(e) {
				if (typeof this.onerror == "function") {
					this.onerror(e.message);
				}
			}
			var uint8array = new Uint8Array(arraybuffer);
			switch (uint8array[0]) {
				case 255: /*No Data – there is no pending request, so there is no data to return from the circuit */
				break;
				case 254: /* Pending – the request is still being processed.  Ensure that you have waited the minimum time to guarantee a response */
					setTimeout(_.bind(this), 100);
				break;
				case   2: /* Failed – the request failed */
					if (typeof this.onerror == "function") {
						this.onerror("Request failed.");
					}
				break
				case   1: /* Success – the requested information is ready */
					uint8array = uint8array.subarray(1);
					uint8array = uint8array.map(v => v &= ~0x80);
					uint8array = uint8array.filter(v => v != 0);
					if (typeof this.onresult == "function") {
						this.onresult( String.fromCharCode.apply(null, uint8array)  );
					}
				break;
			}
		}.bind(this), 100);
	},
	__chip_address: 97,
	__value: null
});